export default function() {
  return [
    {
        title: "Home",
        to: "/home",
        htmlBefore: '<i class="material-icons">home</i>',
        htmlAfter: ""
    },
    {
        title: "Apps",
        to: "/apps",
        htmlBefore: '<i class="material-icons">mobile_screen_share</i>',
        htmlAfter: ""
    },
    {
        title: "Areas",
        to: "/areas",
        htmlBefore: '<i class="material-icons">map</i>',
        htmlAfter: ""
    },
    {
        title: "Logout",
        to: "/logout/confirm",
        htmlBefore: '<i class="material-icons">logout</i>',
        htmlAfter: ""
    }
    // {
    //     title: "App Themes",
    //     to: "/app-themes",
    //     htmlBefore: '<i class="material-icons">format_paint</i>',
    //     htmlAfter: ""
    // },
    // {
    //     title: "API Details",
    //     to: "/api-details",
    //     htmlBefore: '<i class="material-icons">api</i>',
    //     htmlAfter: ""
    // },
    // {
    //   title: "Users",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/users",
    // }
  ];
}
